import * as React from 'react';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import UploadPlaceholder from '../../constants/icons/UploadPlaceholder';
import { IconButton } from '@mui/material';
import { COLOR_MAP } from '../../constants/ColorNames';
// import CloudUploadIcon from '@mui/icons-material/CloudUpload';
// import { UploadIcon } from '../../constants/icons/UploadIcon';
// import { COLOR_MAP } from '../../constants/ColorNames';


type ImageUploadProps = {
  label?: string;
  onChange: (files: FileList) => void;
  id: string,
  variant?: "contained" | "outlined" | "text",
  type?: 'Button' | 'Placeholder',
  placeholderText? : string
}

const VisuallyHiddenInput = styled('input')`
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  position: absolute;
  bottom: 0;
  left: 0;
  white-space: nowrap;
  width: 1px;
`;

const UploadText = styled('p')`
  margin: 0;
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  color: ${COLOR_MAP.DARK_PURPLE};
  position: absolute;
  bottom: 5rem;
  text-transform: none;
`

const ImageUpload = React.forwardRef<HTMLInputElement, ImageUploadProps>((props, ref) => {
  const { label = 'Browse', variant = "contained", type = 'Button', onChange, id, placeholderText } = props;

  const inputRef = React.useRef<HTMLInputElement | null>(null);

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { files } = event.target;
    files && onChange(files);
  };


  if (type === 'Button')
    return (
      <Button
        component="label"
        variant={variant}
        href="#file-upload"
      >
        {label}
        <VisuallyHiddenInput
          type="file"
          id={id}
          ref={(current) => {
            if (inputRef.current) {
              inputRef.current = current;
            }
            if (ref && typeof ref === 'object') {
              ref.current = current;
            }
          }}
          accept={'image/*'}
          hidden
          onChange={handleInputChange}
        />
      </Button>
    );

  return (
    <Button component="label" href="#file-upload">
      <UploadPlaceholder />
      <UploadText>{placeholderText}</UploadText>
      <VisuallyHiddenInput
        type="file"
        id={id}
        ref={(current) => {
          if (inputRef.current) {
            inputRef.current = current;
          }
          if (ref && typeof ref === 'object') {
            ref.current = current;
          }
        }}
        accept={'image/*'}
        hidden
        onChange={handleInputChange}
      />
    </Button>
  )
})

export default ImageUpload